import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import { getClosest } from '../helpers/DOMManipulation';

const ManagedForm = {

  /**
   * Create the managed form component
   * @param {HTMLFormElement} node Form element
   * @return {void}
   */
  create(node) {
    this.form = node;
    this.tabBar = this.form.querySelector('.tab-bar');

    porta({
      target: node,
      messages: nl,
      onError: (formElement, errors) => {
        errors.forEach((errArr) => {
          this.addValidationErrorToTab(errArr[0]);
        });

        this.switchToErrorTab();
      },
    });
  },

  /**
   * Add validation errors thrown by an input field to the parent tab
   * @param {Node} input
   * @return {void}
   */
  addValidationErrorToTab(input) {
    // Get the parent panel element
    const panel = getClosest(input, '.tab-pane');

    if (!panel) {
      return;
    }

    // Get the tab element by ID
    const panelID = panel.id;
    const panelTab = this.tabBar.querySelector(`[href="#${panelID}"]`);

    // Add invalid class to tab for styling
    if (panelTab) {
      panelTab.className += ' is-invalid';
    }
  },

  /**
   * Switch to the tab with the error
   * @return {void}
   */
  switchToErrorTab() {
    if (!this.tabBar) {
      return;
    }

    let errorTabs = this.tabBar.querySelectorAll('.is-invalid');
    errorTabs = Array.prototype.slice.call(errorTabs);

    if (errorTabs.length) {
      const first = errorTabs[0];

      $(first).tab('show');
    }
  },
};

export default ManagedForm;
